export default __webpack_public_path__ + "static/radar-3eff3feef76c333618717fef78a3ee9b.png";